import useContactStore from '@/stores/ContactStore';
import useInboxStore from '@/stores/InboxStore';
import useUserStore from '@/stores/UserStore';
import { LogOut, ScrollText, SquareUser } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';

import {
  trackLogOutAndMixpanelReset,
  trackUserProfileClicked,
} from '@/lib/analytics-event';
import { removeToken } from '@/lib/utils';
import FeaturebaseChangelogWidget from '@/components/common/FeaturebaseChangelogWidget';

import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

export function UserAvatarMenu() {
  const { user, resetUserStore } = useUserStore(
    useShallow((state) => ({
      user: state.user,
      resetUserStore: state.resetUserStore,
    }))
  );

  const resetContactStore = useContactStore((state) => state.resetContactStore);

  const resetInboxStore = useInboxStore((state) => state.resetInboxStore);

  const navigate = useNavigate();

  if (!user) return null;

  const handleLogout = () => {
    removeToken();

    // reset user store
    resetUserStore();
    // reset contact store
    resetContactStore();
    // reset inbox store
    resetInboxStore();

    // reset mixpanel
    trackLogOutAndMixpanelReset();
    // navigate to login page
    navigate('/login');

    // refresh the page to ensure all state is cleared
    window.location.reload();
  };

  const handleProfile = () => {
    trackUserProfileClicked();
  };

  const openChangelogWidget = () => {
    window.Featurebase('manually_open_changelog_popup');
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Avatar className='h-8 w-8' title='User Profile Menu'>
            <AvatarImage src={user.profile_picture_url} />
            <AvatarFallback className='bg-primary-foreground text-primary'>
              {user.first_name.charAt(0)}
              {user.last_name.charAt(0)}
            </AvatarFallback>
          </Avatar>
        </DropdownMenuTrigger>
        <DropdownMenuContent className='w-40' align='start'>
          <DropdownMenuItem onClick={handleProfile} title='View Profile'>
            Profile
            <DropdownMenuShortcut>
              <SquareUser title='Profile' />
            </DropdownMenuShortcut>
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={openChangelogWidget}
            title='View Changelog'
          >
            Changelog
            <DropdownMenuShortcut>
              <ScrollText title='Changelog' />
            </DropdownMenuShortcut>
          </DropdownMenuItem>

          <DropdownMenuItem onClick={handleLogout} title='Logout'>
            Logout
            <DropdownMenuShortcut>
              <LogOut title='Logout' />
            </DropdownMenuShortcut>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <FeaturebaseChangelogWidget />
    </>
  );
}
